import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";
import { formatNumber } from "web_myplann/Shared/Utils/numberFormatters";

export const getAmountMaxMessage = (t: TranslateFunction, max: number) =>
	t(Resources.Goals.Form.Validations.amountMax, {
		max: formatNumber(max),
		currency: t(Resources.Goals.Amount.currencySign),
	});
